import React from 'react';
import './ShoppingListPage.css'
import ShoppingListForm from './ShoppingListForm/ShoppingListForm'
import ShoppingList from './ShoppingList/ShoppingList';


/**
 * ShoppingListPage
 * Page controlling Shopping List elements
 * Call structure: 
 * ShoppingListPage->ShoppingListForm
 *                 ->ShoppingList->ShoppingListElement->ShoppingListForm
 * @returns
 */
function ShoppingListPage() {
    return (
        <div className={"shopping-list-container"}>
            <ShoppingListForm />
            < ShoppingList />
        </div>
    )
}

export default ShoppingListPage